import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { Plncmm10000sc0000PageModule } from './pages/plncmm10000sc00-00/plncmm10000sc00-00.component.page.module'

/**
 * Dashboard Function モジュール
 * @author nabla2.metamodel.generator
 */
@NgModule({
  declarations: [
  ],
  imports: [
  ],
  exports: [
    Plncmm10000sc0000PageModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
  ]
})
export class CmnfncBaseModule {}


// WEBPACK FOOTER //
// ./src/features/cmnfnc-base/cmnfnc-base.module.ts